import { ReactNode } from "react"
import { Table as Tab } from "flowbite-react"
import cn from "classnames"

interface ITableRow {
  children: ReactNode
  className?: string
}

const TableRow = ({ children, className }: ITableRow) => {
  return <Tab.Row className={cn("row_table bg-transparent hover:bg-[#EFEFEF] transition-colors duration-200", className)}>{children}</Tab.Row>
}

export default TableRow
